import { SET_SUPPLIER_NAME_LIST, SET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS, SET_TRANSPORTER_MAPPING_LIST } from "Constants/actionConstants";

const initialState = {
  contractsDetailsList: [],
  statusDetails: {
    active_count: 2,
    bidding_count: 0,
    loi_count: 0,
    draft_count: 0,
  },
  supplierNameList:[],
  transporterMappingList:[],
};

const SupplierOrTransportationRequestsDashboard = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    
    case SET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS: {
      return {
        ...state,
        statusDetails: payload.statusDetails,
        contractsDetailsList: payload.contractsDetailsList,
      };
    }

    case SET_SUPPLIER_NAME_LIST: {
      return {
        ...state,
        supplierNameList:payload
      };
    }

    case SET_TRANSPORTER_MAPPING_LIST: {
      return {
        ...state,
        transporterMappingList:payload
      };
    }

    default:
      return state;
  }
};

export default SupplierOrTransportationRequestsDashboard;
